import React from "react";
import Button from "./Button";

/**
 * Круглая кнопка только с иконкой.
 *
 * <IconButton icon="print" onClick={handlePrint} title="Печать" />
 * <IconButton icon="trash" variant="danger" title="Удалить" />
 * <IconButton icon="back" size="lg" title="Вернуться к списку" />
 *
 * Обязателен title (он же aria-label): без текста кнопку не озвучит скринридер.
 */
const IconButton = React.forwardRef(function IconButton(
    { icon, title, "aria-label": ariaLabel, size = "md", ...rest },
    ref,
) {
    if (!title && !ariaLabel) {
        // Помогаем поймать ошибку ещё в разработке.
        // eslint-disable-next-line no-console
        console.warn("[IconButton] нужен title или aria-label", { icon });
    }

    return (
        <Button
            ref={ref}
            aria-label={ariaLabel || title}
            icon={icon}
            iconOnly
            size={size}
            title={title}
            {...rest}
        />
    );
});

export default IconButton;
